import { render } from "./managerComponent.vue?vue&type=template&id=78cd6309&scoped=true"
import script from "./managerComponent.vue?vue&type=script&lang=js"
export * from "./managerComponent.vue?vue&type=script&lang=js"

import "./managerComponent.vue?vue&type=style&index=0&id=78cd6309&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78cd6309"]])

export default __exports__